import React, { useEffect, useMemo, useState } from "react";
import { useSymbolContext } from "../../../contexts/Symbol-Context.js";
import { useOrderContext } from "../../../contexts/Order-Context.js";
import { useMetricsContext } from "../../../contexts/Metrics-Context.js";
import { useAuthContext } from "../../../contexts/Auth-Context.js";
import { formatFixedTrimmed, formatPositionToPipSize } from "../../../utils/format.js";
import "./OrderSLTP.scss";

import { Ripple } from 'react-ripple-click';
import 'react-ripple-click/dist/index.css';
import { useTranslation } from "react-i18next";

const SLTP = ({
  isPendingOrder,
  secondPrice,
  isEditPosition,
  positionDetails,
  handleSLPipsChange,
  handleTPPipsChange,
  handleDisabledButton,
  handleProfitChange,
  handleLossChange,
  quantity,
  entryPrice,
  EntryPriceExchangeRate,
  handleSLTPDirection,
  direction: directionProp,
}) => {
  const { t } = useTranslation();
  const errorList = useMemo(() => ({
    buySL: t('validation.buySL'),
    sellSL: t('validation.sellSL'),
    buyTP: t('validation.buyTP'),
    sellTP: t('validation.sellTP'),
    priNeg: t('validation.validPrice'),
    priLower: t('validation.priceLowerThanBid'),
  }), [t]);

  const { symbolInfo, selectedSymbolExchangeRate, selectedSymbolQuoteExchangeRate } = useSymbolContext();

  const { metrics } = useMetricsContext();
  const { user, selectedAuthSymbol } = useAuthContext();

  const [isSLSelected, setIsSLSelected] = useState(
    positionDetails && positionDetails.SL && positionDetails.SL > 0
      ? true
      : false
  );
  const [isTPSelected, setIsTPSelected] = useState(
    positionDetails && positionDetails.TP && positionDetails.TP > 0
      ? true
      : false
  );

  const [pipSize, setPipSize] = useState(0.0);
  const [slPrice, setSlPrice] = useState(
    positionDetails && positionDetails.SL && positionDetails.SL > 0
      ? parseFloat(positionDetails.SL)
      : 0.0
  );
  const [slBalance, setSlBalance] = useState(0.0);
  const [slProfit, setSlProfit] = useState(0.0);
  const [slPips, setSlPips] = useState(0.0);
  const [tpPrice, setTpPrice] = useState(
    positionDetails && positionDetails.TP && positionDetails.TP > 0
      ? parseFloat(positionDetails.TP)
      : 0.0
  );
  const [tpBalance, setTpBalance] = useState(0.0);
  const [tpProfit, setTpProfit] = useState(0.0);
  const [tpPips, setTpPips] = useState(0.0);
  const [slSelectedState, setSlSelectedState] = useState("");
  // Keep in sync with Market-Order Long/Short (same as edit uses position direction)
  const [direction, setDirection] = useState(
    directionProp === "Sell" || directionProp === "Buy" ? directionProp : "Buy"
  );

  useEffect(() => {
    if (directionProp === "Buy" || directionProp === "Sell") {
      setDirection(directionProp);
    }
  }, [directionProp]);

  const [isSLError, setIsSLError] = useState(false);
  const [isTPError, setIsTPError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorMessageTP, setErrorMessageTP] = useState("")

  const displayIfNonZero = (v, decimals = 10) => {
    if (v === null || v === undefined || v === "") return "";
    if (typeof v === "string" && (v === "." || v.endsWith(".") || /^-?\d*\.0+$/.test(v))) {
      return v;
    }
    const n = typeof v === "string" ? Number(v) : v;
    // Empty until the user types — show placeholder "0", not a filled zero.
    if (!Number.isFinite(n) || n === 0) return "";
    return formatFixedTrimmed(n, decimals);
  };
  const parseSltpInput = (val) => {
    if (val === "" || val === "." || /^-?\d*\.$/.test(val) || /^-?\d*\.0+$/.test(val)) {
      return val;
    }
    const numVal = parseFloat(val);
    return isNaN(numVal) ? 0 : numVal;
  };
  useEffect(() => {
    handleDisabledButton(isSLError || isTPError);
  }, [isSLError, isTPError])

  const [tpSelectedState, setTpSelectedState] = useState("");
  useEffect(() => {
    setPipSize(formatPositionToPipSize(symbolInfo.pip_position));
  }, [symbolInfo]);

  useEffect(() => {
    if (slSelectedState === "pips") {
      slPips_fn(slPips);
    } else if (slSelectedState === "price") {
      slPrice_fn(slPrice);
    } else if (slSelectedState === "balance") {
      slBalance_fn(slBalance);
    } else if (slSelectedState === "profit") {
      slProfit_fn(slProfit);
    }

    if (tpSelectedState === "pips") {
      tpPips_fn(tpPips);
    } else if (tpSelectedState === "price") {
      tpPrice_fn(tpPrice);
    } else if (tpSelectedState === "balance") {
      tpBalance_fn(tpBalance);
    } else if (tpSelectedState === "profit") {
      tpProfit_fn(tpProfit);
    }
  }, [direction, quantity, entryPrice, secondPrice]);
  useEffect(() => {
    if (isEditPosition && isSLSelected) {
      reCalculate_slPrice_fn();
    }
    if (isEditPosition && isTPSelected) {
      reCalculate_tpPrice_fn();
    }
  }, []);
  useEffect(() => {
    if (!isEditPosition) {
      setSlPips(0.0);
      handleSLPipsChange(0.0);
      handleTPPipsChange(0.0);
      setSlProfit(0.0);
      setSlBalance(0.0);
      setSlPrice(0.0);
      setTpPrice(0.0);
      setTpPips(0.0);
      setTpProfit(0.0);
      setTpBalance(0.0);
      handleLossChange(0.0);
      handleProfitChange(0.0);
      setSlSelectedState("");
      setTpSelectedState("");
    }
  }, [selectedAuthSymbol]);
  useEffect(() => {
    if (!isEditPosition) {
      setSlPips(0.0);
      handleSLPipsChange(0.0);
      handleTPPipsChange(0.0);
      setSlProfit(0.0);
      setSlBalance(0.0);
      setTpPips(0.0);
      setSlPrice(0.0);
      setTpPrice(0.0);
      setTpProfit(0.0);
      setTpBalance(0.0);
      handleLossChange(0.0);
      handleProfitChange(0.0);
      setSlSelectedState("");
      setTpSelectedState("");
    }
  }, [
    quantity === null ||
    quantity <= 0 ||
    quantity === undefined ||
    isNaN(quantity),
  ]);

  function handleDirection(direction) {
    handleSLTPDirection(direction);
    setDirection(direction);
  }

  const sltpToggle = (e) => {
    if (e.target.checked) {
      handleDirection("Buy");
    } else {
      handleDirection("");
    }
    
    setIsSLSelected(e.target.checked);
    setIsTPSelected(e.target.checked);
    
    // Clear all errors
    setIsSLError(false);
    setIsTPError(false);
    setErrorMessage("");
    setErrorMessageTP("");
    
    // Reset all SL values to 0
    setSlPips(0.0);
    setSlPrice(0.0);
    setSlProfit(0.0);
    setSlBalance(0.0);
    handleSLPipsChange(0.0);
    handleLossChange(0.0);
    setSlSelectedState("");
    
    // Reset all TP values to 0
    setTpPips(0.0);
    setTpPrice(0.0);
    setTpProfit(0.0);
    setTpBalance(0.0);
    handleTPPipsChange(0.0);
    handleProfitChange(0.0);
    setTpSelectedState("");
  };
  const slPips_fn = (e) => {
    setSlSelectedState("pips");
    setSlPips(e);
    handleSLPipsChange(e);

    if (direction == "Buy") {
      const pip_movement = pipSize * e;
      const price = entryPrice - pip_movement;
      if (price > secondPrice || price < 0) {
        setIsSLError(true);
        setErrorMessage(errorList.buySL);
      } else {
        setIsSLError(false);
        setErrorMessage("");
      }
      const loss_profit_in_quote = quantity * (entryPrice - price);
      const loss_profit_in_account_currecny = loss_profit_in_quote * selectedSymbolExchangeRate*EntryPriceExchangeRate;

      const balance = (loss_profit_in_account_currecny / metrics.balance) * 100;

      setSlPrice(price);
      setSlBalance(balance);
      setSlProfit(loss_profit_in_account_currecny);
      handleLossChange(price);
    }

    ///////STOP LOSS DIRECTION SELL
    if (direction == "Sell") {
      const pip_movement = pipSize * e;

      const price = parseFloat(entryPrice) + pip_movement;
      if (price < secondPrice || price < 0) {
        setIsSLError(true);
        setErrorMessage(errorList.sellSL);
      } else {
        setIsSLError(false);
        setErrorMessage("");
      }
      const loss_profit_in_quote = quantity * (price - parseFloat(entryPrice));
      const loss_profit_in_account_currecny =
        loss_profit_in_quote * selectedSymbolExchangeRate*EntryPriceExchangeRate;
      const balance = (loss_profit_in_account_currecny / metrics.balance) * 100;

      setSlPrice(price);
      setSlBalance(balance);
      setSlProfit(loss_profit_in_account_currecny);
      handleLossChange(price);
    }
  };
  const reCalculate_slPrice_fn = () => {
    setSlSelectedState("price");

    if (direction == "Buy") {
      const pip_movement = entryPrice - slPrice;
      const pips = pip_movement / pipSize;
      const loss_profit_in_quote = quantity * (entryPrice - slPrice);

      const loss_profit_in_account_currecny =
        loss_profit_in_quote * selectedSymbolExchangeRate*EntryPriceExchangeRate;
      const balance = (loss_profit_in_account_currecny / metrics.balance) * 100;

      setSlPips(pips);
      handleSLPipsChange(pips);
      setSlBalance(balance);
      setSlProfit(loss_profit_in_account_currecny);
      handleLossChange(parseFloat(slPrice));
    }

    ////////////STOP LOSS DIRECTION SELL
    if (direction == "Sell") {
      const pip_movement =  slPrice - entryPrice;

      const pips = pip_movement / pipSize;

      const loss_profit_in_quote = quantity *  (slPrice - entryPrice);

      const loss_profit_in_account_currecny =
        loss_profit_in_quote * selectedSymbolExchangeRate*EntryPriceExchangeRate;
      const balance = (loss_profit_in_account_currecny / metrics.balance) * 100;

      setSlPips(pips);
      handleSLPipsChange(pips);
      setSlBalance(balance);
      setSlProfit(loss_profit_in_account_currecny);
      handleLossChange(parseFloat(slPrice));
    }
  };
  const slPrice_fn = (e) => {
    setSlSelectedState("price");
    setSlPrice(e);

    if (direction == "Buy") {
      const pip_movement = entryPrice - e;

      if (e < 0 || e > secondPrice) {
        if (e < 0 || e > secondPrice) {
          setIsSLError(true);
          setErrorMessage(errorList.buySL);
        } else {
          setIsSLError(false);
          setErrorMessage("");
        }
      }
      else {
        if (pip_movement < 0) {
          setIsSLError(true);
          setErrorMessage(errorList.priNeg);
        } else {
          setIsSLError(false);
          setErrorMessage("");
        }
      }

      const pips = pip_movement / pipSize;
      const loss_profit_in_quote = quantity * (entryPrice - e);

      const loss_profit_in_account_currecny =
        loss_profit_in_quote * selectedSymbolExchangeRate*EntryPriceExchangeRate;
      const balance = (loss_profit_in_account_currecny / metrics.balance) * 100;

      setSlPips(pips);
      handleSLPipsChange(pips);
      setSlBalance(balance);
      setSlProfit(loss_profit_in_account_currecny);
      handleLossChange(parseFloat(e));
    }

    ////////////STOP LOSS DIRECTION SELL
    if (direction == "Sell") {
      const pip_movement = e - entryPrice;

      if (e < 0 || e < secondPrice) {

        if (e < 0 || e < secondPrice) {
          setIsSLError(true);
          setErrorMessage(errorList.sellSL);
        } else {
          setIsSLError(false);
          setErrorMessage("");
        }
      }
      else {
        if (pip_movement < 0) {
          setIsSLError(true);
          setErrorMessage(errorList.buySL);
        } else {
          setIsSLError(false);
          setErrorMessage("");
        }
      }



      const pips = pip_movement / pipSize;

      const loss_profit_in_quote = quantity * (e - entryPrice);

      const loss_profit_in_account_currecny =
        loss_profit_in_quote * selectedSymbolExchangeRate*EntryPriceExchangeRate;
      const balance = (loss_profit_in_account_currecny / metrics.balance) * 100;

      setSlPips(pips);
      handleSLPipsChange(pips);
      setSlBalance(balance);
      setSlProfit(loss_profit_in_account_currecny);
      handleLossChange(e);
    }
  };
  const slBalance_fn = (e) => {
    setSlSelectedState("balance");
    setSlBalance(e);

    if (direction == "Buy") {
      const loss_profit_in_account_currecny = (metrics.balance / 100) * e;
      const price =
        entryPrice -
        (loss_profit_in_account_currecny / quantity) * selectedSymbolQuoteExchangeRate*1/EntryPriceExchangeRate;
      if (price < 0 || price > secondPrice) {
        setIsSLError(true);
        setErrorMessage(errorList.buySL)
      }
      else {
        setIsSLError(false);
        setErrorMessage("");
      }

      const pip_movement = entryPrice - price;
      const pips = pip_movement / pipSize;

      setSlPips(pips);
      handleSLPipsChange(pips);
      setSlPrice(price);
      setSlProfit(loss_profit_in_account_currecny);
      handleLossChange(price);
    }

    // ////////STOP LOSS DIRECTION SELL
    if (direction == "Sell") {
      const loss_profit_in_account_currecny = (metrics.balance / 100) * e;
      const price =
        parseFloat(entryPrice) +
        (loss_profit_in_account_currecny / quantity) * selectedSymbolQuoteExchangeRate*1/EntryPriceExchangeRate;
      const pip_movement = price - entryPrice;

      if (pip_movement < 0 || price < secondPrice) {
        setIsSLError(true);
        setErrorMessage(errorList.buySL);
      } else {
        setIsSLError(false);
        setErrorMessage("");
      }

      const pips = pip_movement / pipSize;

      setSlPips(pips);
      handleSLPipsChange(pips);
      setSlPrice(price);
      setSlProfit(loss_profit_in_account_currecny);
      handleLossChange(price);
    }
  };
  const slProfit_fn = (e) => {
    setSlSelectedState("profit");
    setSlProfit(e);

    if (direction == "Buy") {
      const balance = (e / metrics.balance) * 100;

      const price = entryPrice - (e / quantity) * selectedSymbolQuoteExchangeRate*1/EntryPriceExchangeRate;

      const pip_movement = entryPrice - price;

      if (price < 0 || price > secondPrice) {
        setIsSLError(true);
        setErrorMessage(errorList.buySL);
      } else {
        setIsSLError(false);
        setErrorMessage("");
      }
      const pips = pip_movement / pipSize;

      setSlPips(pips);
      handleSLPipsChange(pips);
      setSlBalance(balance);
      setSlPrice(price);
      handleLossChange(price);
    }

    if (direction == "Sell") {
      const balance = (e / metrics.balance) * 100;

      const price = parseFloat(entryPrice) + (e / quantity) * selectedSymbolQuoteExchangeRate*1/EntryPriceExchangeRate;

      const pip_movement = price - entryPrice;

      if (pip_movement < 0) {
        setIsSLError(true);
        setErrorMessage(errorList.buySL);
      } else {
        setIsSLError(false);
        setErrorMessage("");
      }

      const pips = pip_movement / pipSize;

      setSlPips(pips);
      handleSLPipsChange(pips);
      setSlBalance(balance);
      setSlPrice(price);
      handleLossChange(price);
    }
  };
  const tpPips_fn = (e) => {
    setTpSelectedState("pips");
    setTpPips(e);
    handleTPPipsChange(e);
    if (direction == "Buy") {
      const pip_movement = e * pipSize;
      const price = parseFloat(entryPrice) + pip_movement;
      // Buy TP vs bid (secondPrice), not ask
      if (!(parseFloat(secondPrice) > 0) || price < parseFloat(secondPrice)) {
        setIsTPError(true);
        setErrorMessageTP(errorList.buyTP);
      } else {
        setIsTPError(false);
        setErrorMessageTP("");
      }
      const loss_profit_in_quote = quantity * (price - parseFloat(entryPrice));

      const loss_profit_in_account_currecny =
        loss_profit_in_quote * selectedSymbolExchangeRate*EntryPriceExchangeRate;

      const balance = (loss_profit_in_account_currecny / metrics.balance) * 100;
      setTpPrice(price);
      setTpBalance(balance);
      setTpProfit(loss_profit_in_account_currecny);

      handleProfitChange(price);
    }

    ///////TAKE PROFIT DIRECTION SELL
    if (direction == "Sell") {
      const pip_movement = e * pipSize;
      const price = entryPrice - pip_movement;
      // Sell TP vs ask (secondPrice) — same as edit SLTP: invalid when TP > ask
      if (!(parseFloat(secondPrice) > 0) || price < 0 || price > parseFloat(secondPrice)) {
        setIsTPError(true);
        setErrorMessageTP(errorList.sellTP);
      } else {
        setIsTPError(false);
        setErrorMessageTP("");
      }
      const loss_profit_in_quote = quantity * (entryPrice - price);
      const loss_profit_in_account_currecny =
        loss_profit_in_quote * selectedSymbolExchangeRate*EntryPriceExchangeRate;
      const balance = (loss_profit_in_account_currecny / metrics.balance) * 100;

      setTpPrice(price);
      setTpBalance(balance);
      setTpProfit(loss_profit_in_account_currecny);

      handleProfitChange(price);
    }
  };
  const tpPrice_fn = (e) => {
    setTpSelectedState("price");
    setTpPrice(e);

    if (direction == "Buy") {
      const pip_movement = entryPrice - e;

      // Buy TP must be > bid
      if (e < 0 || !(parseFloat(secondPrice) > 0) || e < parseFloat(secondPrice)) {
        setIsTPError(true);
        setErrorMessageTP(e < 0 ? errorList.priNeg : errorList.buyTP);
      } else {
        setIsTPError(false);
        setErrorMessageTP("");
      }

      const pips = Math.abs(pip_movement) / pipSize;
      const loss_profit_in_quote = quantity * (e - entryPrice);
      const loss_profit_in_account_currecny =
        loss_profit_in_quote * selectedSymbolExchangeRate*EntryPriceExchangeRate;
      const balance = (loss_profit_in_account_currecny / metrics.balance) * 100;

      setTpPips(pips);
      handleTPPipsChange(pips);
      setTpBalance(balance);
      setTpProfit(loss_profit_in_account_currecny);
      handleProfitChange(e);
    }

    ////////////Take PROFIT DIRECTION SELL
    if (direction == "Sell") {
      const pip_movement = entryPrice - e;
      // Sell TP must be < ask (secondPrice)
      if (e < 0 || !(parseFloat(secondPrice) > 0) || e > parseFloat(secondPrice)) {
        setIsTPError(true);
        setErrorMessageTP(e < 0 ? errorList.priNeg : errorList.sellTP);
      } else {
        setIsTPError(false);
        setErrorMessageTP("");
      }
      const pips = Math.abs(pip_movement) / pipSize;
      const loss_profit_in_quote = Math.abs(quantity * (e - entryPrice));
      const loss_profit_in_account_currecny =
        loss_profit_in_quote * selectedSymbolExchangeRate*EntryPriceExchangeRate;
      const balance = (loss_profit_in_account_currecny / metrics.balance) * 100;

      setTpPips(pips);
      handleTPPipsChange(pips);
      setTpBalance(balance);
      setTpProfit(loss_profit_in_account_currecny);
      handleProfitChange(e);
    }
  };
  const reCalculate_tpPrice_fn = () => {
    setTpSelectedState("price");

    if (direction == "Buy") {
      const pip_movement = entryPrice - tpPrice;
      const pips = pip_movement / pipSize;
      const loss_profit_in_quote = quantity * (tpPrice - entryPrice);
      const loss_profit_in_account_currecny =
        loss_profit_in_quote * selectedSymbolExchangeRate*EntryPriceExchangeRate;
      const balance = (loss_profit_in_account_currecny / metrics.balance) * 100;

      setTpPips(Math.abs(pips));
      handleTPPipsChange(pips);
      setTpBalance(balance);
      setTpProfit(loss_profit_in_account_currecny);
      handleProfitChange(tpPrice);
    }

    ////////////Take PROFIT DIRECTION SELL
    // Sell TP is below entry → profit = qty * (entry - tp). (tp - entry) flips sign on reopen.
    if (direction == "Sell") {
      const pip_movement = entryPrice - tpPrice;
      const pips = pip_movement / pipSize;
      const loss_profit_in_quote = quantity * (entryPrice - tpPrice);
      const loss_profit_in_account_currecny =
        loss_profit_in_quote * selectedSymbolExchangeRate*EntryPriceExchangeRate;
      const balance = (loss_profit_in_account_currecny / metrics.balance) * 100;

      setTpPips(Math.abs(pips));
      handleTPPipsChange(Math.abs(pips));
      setTpBalance(balance);
      setTpProfit(loss_profit_in_account_currecny);
      handleProfitChange(tpPrice);
    }
  };
  const tpBalance_fn = (e) => {
    setTpSelectedState("balance");
    setTpBalance(e);

    if (direction == "Buy") {
      const loss_profit_in_account_currecny = (metrics.balance / 100) * e;

      const price =
        parseFloat(entryPrice) +
        (loss_profit_in_account_currecny / quantity) * selectedSymbolQuoteExchangeRate*1/EntryPriceExchangeRate;

      const pip_movement = price - entryPrice;

      if (!(parseFloat(secondPrice) > 0) || price < parseFloat(secondPrice)) {
        setIsTPError(true);
        setErrorMessageTP(errorList.buyTP);
      } else {
        setIsTPError(false);
        setErrorMessageTP("");
      }

      const pips = pip_movement / pipSize;

      setTpPips(pips);
      handleTPPipsChange(pips);
      setTpPrice(price);
      setTpProfit(loss_profit_in_account_currecny);

      handleProfitChange(price);
    }

    ////////Take Profit DIRECTION SELL
    if (direction == "Sell") {
      const loss_profit_in_account_currecny = (metrics.balance / 100) * e;

      const price = Math.abs(entryPrice -
        (loss_profit_in_account_currecny / quantity) * selectedSymbolQuoteExchangeRate*1/EntryPriceExchangeRate);

      if (price < 0 || !(parseFloat(secondPrice) > 0) || price > parseFloat(secondPrice)) {
        setIsTPError(true);
        setErrorMessageTP(errorList.sellTP);
      } else {
        setIsTPError(false);
        setErrorMessageTP("");
      }

      const pip_movement = Math.abs(price - entryPrice);

      const pips = pip_movement / pipSize;

      setTpPips(pips);
      handleTPPipsChange(pips);
      setTpPrice(price);
      setTpProfit(loss_profit_in_account_currecny);

      handleProfitChange(price);
    }
  };
  const tpProfit_fn = (e) => {
    setTpSelectedState("profit");
    setTpProfit(e);

    if (direction == "Buy") {
      const balance = (e / metrics.balance) * 100;

      const price = parseFloat(entryPrice) + (e / quantity) * selectedSymbolQuoteExchangeRate*1/EntryPriceExchangeRate;

      const pip_movement = Math.abs(entryPrice - price);

      if (!(parseFloat(secondPrice) > 0) || price < parseFloat(secondPrice)) {
        setIsTPError(true);
        setErrorMessageTP(errorList.buyTP);
      } else {
        setIsTPError(false);
        setErrorMessageTP("");
      }

      const pips = pip_movement / pipSize;

      setTpPips(pips);
      handleTPPipsChange(pips);
      setTpBalance(balance);
      setTpPrice(price);

      handleProfitChange(price);
    }

    if (direction == "Sell") {
      const balance = (e / metrics.balance) * 100;

      const price = entryPrice - (e / quantity) * selectedSymbolQuoteExchangeRate*1/EntryPriceExchangeRate;

      if (price < 0 || !(parseFloat(secondPrice) > 0) || price > parseFloat(secondPrice)) {
        setIsTPError(true);
        setErrorMessageTP(errorList.sellTP);
      } else {
        setIsTPError(false);
        setErrorMessageTP("");
      }

      const pip_movement = entryPrice - price;

      const pips = pip_movement / pipSize;

      setTpPips(pips);
      handleTPPipsChange(pips);
      setTpBalance(balance);
      setTpPrice(price);

      handleProfitChange(price);
    }
  };
  const isDisabledSLInput = () => {
    if (quantity > 0 && isSLSelected && parseFloat(entryPrice) > 0) {
      return false;
    } else {
      return true;
    }
  };
  const isDisabledTPInput = () => {
    if (quantity > 0 && isTPSelected && parseFloat(entryPrice) > 0) {
      return false;
    } else {
      return true;
    }
  };
  const handleScroll = (e) => {
    // e.preventDefault();
    e.target.blur();
  }
  return (
    <>
      <div
        className="sltp-container-binance"
      >
        <div className="left">
          <div className="stop-loss ">
            <div className="sltp-checkbox-binance">
              <div className="">
                <input
                  hidden
                  type="checkbox"
                  id="stop_loss"
                  checked={isSLSelected}
                  onChange={sltpToggle}
                />
                <label
                  htmlFor="stop_loss"
                  className="my-chk-xbx"
                  role={isSLSelected ? "checked" : "unchecked"}
                >
                  <div
                    className="chkx-xbx"
                    onClick={() => {
                      // mkRipple(j);
                    }}
                    style={{
                      position: 'relative',
                      overflow: 'hidden',
                      isolation: 'isolate',
                    }}
                  >
                    <Ripple />
                  </div>
                  <span className="col-white">SL/TP</span>
                </label>
              </div>
              {
                (isSLSelected || isTPSelected) && (
                  <div className="position-toggle">
                    <button
                      className={`toggle-button ${direction === "Buy" ? "active" : ""}`}
                      onClick={() => handleDirection("Buy")}
                    >
                      Long
                    </button>
                    <button
                      className={`toggle-button ${direction === "Sell" ? "active" : ""}`}
                      onClick={() => handleDirection("Sell")}
                    >
                      Short
                    </button>
                  </div>
                )
              }
            </div>
          </div>
        </div>

        {(isSLSelected || isTPSelected) && (
          <div className="sltp-grid">
            {/* LEFT COLUMN: SL */}
            <div className="column left">
              {/* SL Pips */}
              <div className="input-group">
                <label>{t('ea.slPips')}</label>
                <input
                  type="number"
                  value={displayIfNonZero(slPips)}
                  placeholder="0"
                  maxLength={32}
                  onChange={(e) => {
                    const val = e.target.value;
                    if (val.length <= 32) {
                      slPips_fn(parseSltpInput(val));
                    }
                  }}
                  disabled={isDisabledSLInput()}
                  className={`sl_pips ${isDisabledSLInput() ? "disabled-fields" : ""}`}
                  onWheel={handleScroll}
                  step={pipSize}
                />
              </div>
          
              {/* SL Price */}
              <div className="input-group">
                <label>{t('ea.slPrice')}</label>
                <input
                  type="number"
                  value={displayIfNonZero(slPrice)}
                  placeholder="0"
                  maxLength={32}
                  onChange={(e) => {
                    const val = e.target.value;
                    if (val.length <= 32) {
                      slPrice_fn(parseSltpInput(val));
                    }
                  }}
                  disabled={isDisabledSLInput()}
                  className={`sl_price ${isDisabledSLInput() ? "disabled-fields" : ""}`}
                  onWheel={handleScroll}
                  step={0.001}
                  style={
                    isSLError && !isPendingOrder
                      ? { background: "#8e3f3f", borderWidth: "2px", borderStyle: "solid" }
                      : {}
                  }
                  title={errorMessage}
                />
              </div>
          
              {/* SL Balance */}
              <div className="input-group">
                <label>{t('ea.slBalance')}</label>
                <input
                  type="number"
                  value={displayIfNonZero(slBalance)}
                  placeholder="0"
                  maxLength={32}
                  onChange={(e) => {
                    const val = e.target.value;
                    if (val.length <= 32) {
                      slBalance_fn(parseSltpInput(val));
                    }
                  }}
                  disabled={isDisabledSLInput()}
                  className={`sl_balance ${isDisabledSLInput() ? "disabled-fields" : ""}`}
                  onWheel={handleScroll}
                  step={0.01}
                />
              </div>
          
              {/* SL Profit */}
              <div className="input-group">
                <label>PNL ~ {{'EUR': '€', 'USD': '$'}[user?.userCurrencyName] || '€'}</label>
                <input
                  type="number"
                  value={displayIfNonZero(slProfit)}
                  placeholder="0"
                  maxLength={32}
                  onChange={(e) => {
                    const val = e.target.value;
                    if (val.length <= 32) {
                      slProfit_fn(parseSltpInput(val));
                    }
                  }}
                  disabled={isDisabledSLInput()}
                  className={`sl_profit ${isDisabledSLInput() ? "disabled-fields" : ""}`}
                  onWheel={handleScroll}
                  onKeyDown={(e) => {
                    if (e.key === "ArrowUp") {
                      e.preventDefault();
                      const inc = (+slPips + +pipSize);
                      slPips_fn(inc);
                    } else if (e.key === "ArrowDown") {
                      e.preventDefault();
                      const dec = (+slPips - +pipSize);
                      slPips_fn(dec);
                    }
                  }}
                />
              </div>
            </div>
          
            {/* RIGHT COLUMN: TP */}
            <div className="column right">
              {/* TP Pips */}
              <div className="input-group">
                <label>{t('ea.tpPips')}</label>
                <input
                  type="number"
                  value={displayIfNonZero(tpPips)}
                  placeholder="0"
                  maxLength={32}
                  onChange={(e) => {
                    const val = e.target.value;
                    if (val.length <= 32) {
                      tpPips_fn(parseSltpInput(val));
                    }
                  }}
                  disabled={isDisabledTPInput()}
                  className={`tp_pips ${isDisabledTPInput() ? "disabled-fields" : ""}`}
                  onWheel={handleScroll}
                  step={pipSize}
                />
              </div>
          
              {/* TP Price */}
              <div className="input-group">
                <label>{t('ea.tpPrice')}</label>
                <input
                  type="number"
                  value={displayIfNonZero(tpPrice)}
                  placeholder="0"
                  maxLength={32}
                  onChange={(e) => {
                    const val = e.target.value;
                    if (val.length <= 32) {
                      tpPrice_fn(parseSltpInput(val));
                    }
                  }}
                  disabled={isDisabledTPInput()}
                  className={`tp_price ${isDisabledTPInput() ? "disabled-fields" : ""}`}
                  onWheel={handleScroll}
                  step={0.001}
                  style={
                    isTPError && !isPendingOrder
                      ? { background: "#8e3f3f", borderWidth: "2px", borderStyle: "solid" }
                      : {}
                  }
                  title={errorMessageTP}
                />
              </div>
          
              {/* TP Balance */}
              <div className="input-group">
                <label>{t('ea.tpBalance')}</label>
                <input
                  type="number"
                  value={displayIfNonZero(tpBalance)}
                  placeholder="0"
                  maxLength={32}
                  onChange={(e) => {
                    const val = e.target.value;
                    if (val.length <= 32) {
                      tpBalance_fn(parseSltpInput(val));
                    }
                  }}
                  disabled={isDisabledTPInput()}
                  className={`tp_balance ${isDisabledTPInput() ? "disabled-fields" : ""}`}
                  onWheel={handleScroll}
                  step={0.01}
                />
              </div>
          
              {/* TP Profit */}
              <div className="input-group">
                <label>PNL ~ {{'EUR': '€', 'USD': '$'}[user?.userCurrencyName] || '€'}</label>
                <input
                  type="number"
                  value={displayIfNonZero(tpProfit)}
                  placeholder="0"
                  maxLength={32}
                  onChange={(e) => {
                    const val = e.target.value;
                    if (val.length <= 32) {
                      tpProfit_fn(parseSltpInput(val));
                    }
                  }}
                  disabled={isDisabledTPInput()}
                  className={`tp_profit ${isDisabledTPInput() ? "disabled-fields" : ""}`}
                  onWheel={handleScroll}
                  onKeyDown={(e) => {
                    if (e.key === "ArrowUp") {
                      e.preventDefault();
                      const inc = (+tpPips + +pipSize);
                      tpPips_fn(inc);
                    } else if (e.key === "ArrowDown") {
                      e.preventDefault();
                      const dec = (+tpPips - +pipSize);
                      tpPips_fn(dec);
                    }
                  }}
                />
              </div>
            </div>
          </div>
        
        )}

      </div>
    </>
  );
};

export default SLTP;
